import { Routes, Route } from "react-router-dom";
import { Dashboard } from "../../role-based-code/dashboard";
import { Descriptive } from "../../role-based-code/descriptive";
import { ChatScreen } from "../../role-based-code/chat-screen";
import { Quiz } from "../../role-based-code/quiz";
import {
  ROUTE_CHAT,
  ROUTE_LEARNING_ASSETS,
  ROUTE_AI_ANALYSIS,
  ROUTE_QUIZ,
  ROUTE_DASHBOARD,
  ROUTE_LOGIN,
  ROUTE_AI_GENERATE,
  ROUTE_PROFILE,
  ROUTE_COMPETITIVE_EXAM,
  ROUTE_DESCRIPTIVE,
  ROUTE_MOCK_TEST,
  ROUTE_INTERVIEW,
  // ROUTE_PAYMENT_SUCCESS,
} from "../studentRoute.js";
import { Login } from "../../role-based-code/login";
import { AiGenerator } from "../../role-based-code/ai-generator";
import { AiAnalysis } from "../../role-based-code/ai-analysis";
import { LearningAssets } from "../../role-based-code/learning-assets";
import { CompetitiveExam } from "../../role-based-code/competitive-exam";
import { Profile } from "../../role-based-code/profile";
import {MockTest} from "../../role-based-code/mock-test";
import { UpscInterview } from "../../role-based-code/upsc-interview";
// import { PaymentSuccess } from "../../role-based-code/payment-success/index.jsx";


export const StudentRoutes = () => (
  <Routes>
    <Route path={ROUTE_DASHBOARD} element={<Dashboard />} />
    <Route path={ROUTE_DESCRIPTIVE} element={<Descriptive />} />
    <Route path={ROUTE_CHAT} element={<ChatScreen />} />
    <Route path={ROUTE_QUIZ} element={<Quiz />} />
    <Route path={ROUTE_LOGIN} element={<Login />} />
    <Route path={ROUTE_LEARNING_ASSETS} element={<LearningAssets />} />
    <Route path={ROUTE_AI_GENERATE} element={<AiGenerator />} />
    <Route path={ROUTE_AI_ANALYSIS} element={<AiAnalysis />} />
    <Route path={ROUTE_COMPETITIVE_EXAM} element={<CompetitiveExam />} />
    <Route path={ROUTE_MOCK_TEST} element={<MockTest />} />
    <Route path={ROUTE_INTERVIEW} element={<UpscInterview />} />
    <Route path={ROUTE_PROFILE} element={<Profile />} />
        {/* <Route path={ROUTE_PAYMENT_SUCCESS} element={<PaymentSuccess />} /> */}
    
  </Routes>
);
